import { SectionHeading } from "~/components/DetailsPage/components";
import { EmptySection } from "~/components/vulnerabilities";
import { useAssetSoftwareAdvisories } from "~/pages/inventory/components/AssetSoftwareDetails/AssetSoftwareAdvisories/hooks/useAssetSoftwareAdvisories";
import { FindingsTable } from "../../Findings/FindingsTable/FindingsTable";
import { Box } from "@mui/material";
import { LoadingFailedPage } from "~/components/loading";

type SoftwareAdvisoriesProps = {
  assetMrn: string;
  softwareMrn: string;
};

export const AssetSoftwareAdvisories = ({
  assetMrn,
  softwareMrn,
}: SoftwareAdvisoriesProps) => {
  const {
    advisories,
    totalCount,
    paginationProps,
    hasAdvisories,
    hasError,
    assetId,
  } = useAssetSoftwareAdvisories({
    assetMrn,
    softwareMrn,
  });

  if (hasError) {
    return <LoadingFailedPage what="Advisories" />;
  }

  return (
    <Box data-testid="software-advisories">
      <SectionHeading heading="Advisories" />
      {hasAdvisories ? (
        <FindingsTable
          paginationProps={paginationProps}
          findings={advisories}
          totalCount={totalCount}
          entityMrn={assetMrn}
          context="advisory"
          assetId={assetId}
        />
      ) : (
        <EmptySection
          id="software-advisories-empty"
          text="There are currently no advisories for this software"
        />
      )}
    </Box>
  );
};
